import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { CompanyDataAnalysisOptions, defaultChartOrTableHeight } from './CompanyDataAnalysisService';
import { Symbols } from '@/symbols';
import { CompanyDataAnalysisViewType } from './CompanyDataAnalysis.type';
import _ from 'lodash';
import { CompanyDataAnalysisEventKey, CompanyDataAnalysisKeyType } from '@/apis/service/company/CompanyDataAnalysisApi.type';
let CompanySynapseDataAnalysisService = class CompanySynapseDataAnalysisService {
    constructor(companyDataAnalysisService, companyDataAnalysisApi, i18n) {
        this.companyDataAnalysisService = companyDataAnalysisService;
        this.companyDataAnalysisApi = companyDataAnalysisApi;
        this.i18n = i18n;
        /**
         * 新用户获取权限配置
         */
        this.newUserPermissionOption = new CompanyDataAnalysisOptions();
        /**
         * 新用户获取权限 Detail 配置
         */
        this.newUserPermissionDetailOption = new CompanyDataAnalysisOptions();
        this.synapseActiveUserDetailOption = new CompanyDataAnalysisOptions();
        this.newUserPermissionConfigInit();
        this.newUserPermissionDetailConfigInit();
        this.synapseActiveUserDetailConfigInit();
    }
    newUserPermissionConfigInit() {
        this.newUserPermissionOption.reportName = CompanyDataAnalysisKeyType.SYNAPSE_NEW_USER;
        this.newUserPermissionOption.title = this.i18n.t('backoffice.company.dataAnalysis.overview');
        this.newUserPermissionOption.canCollapse = false;
        this.newUserPermissionOption.tips = [];
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
        };
        this.newUserPermissionOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.newUserPermissionOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.newUserPermissionOption.statistics = [];
        this.newUserPermissionOption.chartId = 'newSynapseUserPermissionChart';
        this.newUserPermissionOption.chartHeight = defaultChartOrTableHeight.defaultChartHeight;
    }
    getNewUserPermissionData(params) {
        this.newUserPermissionOption.loading = true;
        const newUserPermissionParams = { ...params, report_name: this.newUserPermissionOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(newUserPermissionParams).then(data => {
            this.newUserPermissionOption.Updated = data.data_date;
            this.newUserPermissionDetailOption.Updated = data.data_date;
            this.synapseActiveUserDetailOption.Updated = data.data_date;
            this.newUserPermissionOption.noData = data.data_detail.length === 0;
            this.newUserPermissionOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.SYNAPSE);
            const optionParams = {
                data: data.data_detail,
                user_count: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
                key: CompanyDataAnalysisEventKey.SYNAPSE,
            };
            this.newUserPermissionOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.newUserPermissionOption.noData = true;
        }).finally(() => {
            this.newUserPermissionOption.loading = false;
        });
    }
    newUserPermissionDetailConfigInit() {
        this.newUserPermissionDetailOption.reportName = CompanyDataAnalysisKeyType.SYNAPSE_NEW_USER;
        this.newUserPermissionDetailOption.title = this.i18n.t('backoffice.company.dataAnalysis.userDetails');
        this.newUserPermissionDetailOption.tips = [
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.synapseLoginCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.synapseLoginCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.synapseLoginTotalCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.synapseLoginTotalCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.joinDate'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.joinDateTips'),
            }, {
                label: this.i18n.t('backoffice.company.dataAnalysis.upgradeOrApplyTrial'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.upgradeOrApplyTrialTips'),
            }
        ];
        this.newUserPermissionDetailOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.newUserPermissionDetailOption.tableOptions.paginationOptions.enabled = true;
        this.newUserPermissionDetailOption.tableOptions.paginationOptions.perPageDropdownEnabled = false;
        this.newUserPermissionDetailOption.canChangeViewType = false;
        this.newUserPermissionDetailOption.viewType = CompanyDataAnalysisViewType.Table;
        this.newUserPermissionDetailOption.canCollapse = false;
        this.newUserPermissionDetailOption.tableFields = this.companyDataAnalysisService.getUserTableColumns(CompanyDataAnalysisEventKey.SYNAPSE);
        this.newUserPermissionDetailOption.tableOptions.columns = this.newUserPermissionDetailOption.tableFields;
    }
    async getNewUserPermissionDetailsData(params) {
        let newUserPermissionDetailParams = _.cloneDeep(params);
        this.newUserPermissionDetailOption.loading = true;
        newUserPermissionDetailParams = this.companyDataAnalysisService.getDetailTableDefaultParams(params, this.newUserPermissionDetailOption.reportName);
        // 先获取字段设置
        this.newUserPermissionDetailOption.tableOptions.columns = await this.companyDataAnalysisService.getFiledSettingColumns(this.newUserPermissionOption.reportName, this.newUserPermissionDetailOption.tableFields);
        return this.companyDataAnalysisApi.getCompanyDataAnalysisUserPrivileges(newUserPermissionDetailParams).then(data => {
            this.newUserPermissionDetailOption.noData = data.iTotalRecords === 0;
            this.newUserPermissionDetailOption.tableOptions.paginationOptions.setCurrentPage = Number(data.s_echo);
            this.newUserPermissionDetailOption.tableOptions.totalRecords = data.iTotalRecords;
            this.newUserPermissionDetailOption.tableOptions.totalRows = data.iTotalDisplayRecords;
            this.newUserPermissionDetailOption.tableOptions.rows = this.companyDataAnalysisService.getUserTableRows(data.aaData, CompanyDataAnalysisEventKey.SYNAPSE);
        }).catch(() => {
            this.newUserPermissionDetailOption.noData = true;
        }).finally(() => {
            this.newUserPermissionDetailOption.loading = false;
        });
    }
    synapseActiveUserDetailConfigInit() {
        this.synapseActiveUserDetailOption.reportName = CompanyDataAnalysisKeyType.SYNAPSE_SEARCH;
        this.synapseActiveUserDetailOption.title = this.i18n.t('backoffice.company.dataAnalysis.activeUserTitle');
        this.synapseActiveUserDetailOption.tips = [
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.synapseLoginCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.synapseLoginCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.synapseLoginTotalCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.synapseLoginTotalCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.synapseSearchCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.synapseSearchCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.synapseViewDetailCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.synapseViewDetailCountTips'),
            }
        ];
        this.synapseActiveUserDetailOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeight;
        this.synapseActiveUserDetailOption.tableOptions.paginationOptions.enabled = true;
        this.synapseActiveUserDetailOption.tableOptions.paginationOptions.perPageDropdownEnabled = false;
        this.synapseActiveUserDetailOption.canChangeViewType = false;
        this.synapseActiveUserDetailOption.viewType = CompanyDataAnalysisViewType.Table;
        this.synapseActiveUserDetailOption.canCollapse = true;
        this.synapseActiveUserDetailOption.tableFields = this.companyDataAnalysisService.getSynapseActiveUserTableColumns();
        this.synapseActiveUserDetailOption.tableOptions.columns = this.synapseActiveUserDetailOption.tableFields;
    }
    async synapseActiveUserDetailData(params) {
        let synapseActiveUserDetailParams = _.cloneDeep(params);
        this.synapseActiveUserDetailOption.loading = true;
        synapseActiveUserDetailParams = this.companyDataAnalysisService.getDetailTableDefaultParams(params, this.synapseActiveUserDetailOption.reportName);
        // 先获取字段设置
        this.synapseActiveUserDetailOption.tableOptions.columns = await this.companyDataAnalysisService.getFiledSettingColumns(this.synapseActiveUserDetailOption.reportName, this.synapseActiveUserDetailOption.tableFields);
        return this.companyDataAnalysisApi.getCompanyDataAnalysisUserPrivilegesSummary(synapseActiveUserDetailParams).then(data => {
            this.synapseActiveUserDetailOption.noData = data.iTotalRecords === 0;
            this.synapseActiveUserDetailOption.tableOptions.paginationOptions.setCurrentPage = Number(data.s_echo);
            this.synapseActiveUserDetailOption.tableOptions.totalRecords = data.iTotalRecords;
            this.synapseActiveUserDetailOption.tableOptions.totalRows = data.iTotalDisplayRecords;
            this.synapseActiveUserDetailOption.tableOptions.rows = this.companyDataAnalysisService.getSynapseActiveUserTableRows(data.aaData);
        }).catch(() => {
            this.synapseActiveUserDetailOption.noData = true;
        }).finally(() => {
            this.synapseActiveUserDetailOption.loading = false;
        });
    }
    async initData(params) {
        Promise.all([
            this.getNewUserPermissionData(params),
            this.getNewUserPermissionDetailsData(params),
            this.synapseActiveUserDetailData(params)
        ]);
    }
};
CompanySynapseDataAnalysisService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CompanyDataAnalysisService)),
    __param(1, inject(Symbols.CompanyDataAnalysisApi)),
    __param(2, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object])
], CompanySynapseDataAnalysisService);
export { CompanySynapseDataAnalysisService };
